import CampaignIcon from "@mui/icons-material/Campaign";
import ListCampaignApplications from "./List";

import { APPLICATIONS, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";
import CreateCampaignsApplications from "./Create";

export const resources = {
  isMenu: true,
  icon: <CampaignIcon />,
  name: SpecialistServicePath + APPLICATIONS,
  title: "Кандидатури към Кампании",
  list: <ListCampaignApplications />,
  create: <CreateCampaignsApplications />,
  permission: permissions.canPreviewSpecialistCampaignsApplications,
  showPermission: permissions.canPreviewSpecialistCampaignsApplications,
  createPermission: permissions.canManageSpecialistCampaignsApplications,
};
